import type { ChangeOrigin } from '@shared/types';

/** The one shape the menu needs from VersionListResponse['versions'][number]. */
export interface VersionRow {
  version: number;
  changeSummary: string;
  changedBy: string;
  changeOrigin?: ChangeOrigin;
  createdAt: string;
}

/**
 * docs/simplify.md §2g: the VersionsMenu hides agent-housekeeping rows
 * (`changeOrigin: 'system'` — skeleton assembly, sizing/imagery folded into
 * one save, tier regen, the decisions ledger) by default, the same filter
 * `list_versions` (the agent tool) and done.summary already apply. `showAll`
 * is the menu's own toggle state. A row with no `changeOrigin` predates this
 * field — treated as visible, same as an explicit 'agent'/'rep'.
 */
export function visibleVersions(versions: VersionRow[], showAll: boolean): VersionRow[] {
  if (showAll) return versions;
  return versions.filter((v) => v.changeOrigin !== 'system');
}

/** Whether the toggle has anything to reveal — lets the menu skip rendering it on a proposal with no housekeeping rows yet. */
export function hasHiddenSystemVersions(versions: VersionRow[]): boolean {
  return versions.some((v) => v.changeOrigin === 'system');
}
